<div class="container" *ngIf="!viewKey">
    <div class="row g-3">
        <div class="col-12">
            <div class="d-flex">
                <span class="material-symbols-outlined fs-2 me-3 pointer" (click)="bankSystem()">
                    arrow_back
                </span>
                <h1>Service Secret Key Platform</h1>
                <button class="btn btn-primary ms-3" (click)="setNewRealm()">Add Realm</button>
            </div>
        </div>
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>Realm</th>
                        <th>Realm Client Id</th>
                        <th>Realm Client Secret</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rm of realmItems">
                        <td>{{rm.RealmName}}</td>
                        <td>{{rm.RealmClientId}}</td>
                        <td>{{rm.RealmClientSecret}}</td>
                        <td class="text-end">
                            <button class="btn btn-primary" (click)="viewRealm(rm)">get member secret key</button>
                            <button class="btn btn-cancel ms-2" (click)="setOtpKey(rm)">set otp key</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<div class="container" *ngIf="viewKey">
    <div class="row g-3">
        <div class="col-12">
            <div class="d-flex align-content-center">
                <span class="material-symbols-outlined fs-2 me-3 pointer" (click)="viewKey = false">
                    arrow_back
                </span>
                <h1>Member Secret Key</h1>
                <button class="btn btn-primary ms-3" (click)="addSecretkey()">Add Member Key</button>
            </div>
        </div>
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>Member Client Id</th>
                        <th colspan="2">Member Client Secret</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let mi of memberItems">
                        <td>{{mi.MemberClientId}}</td>
                        <td>{{mi.MemberClientSecret}}</td>
                        <td class="text-end">
                            <button class="btn btn-cancel" (click)="resetSecretkey(mi)">
                                reset secret key
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<p-dialog header="Set OTP Key " [(visible)]="viewOtpKey" [breakpoints]="{ '960px': '90vw' }" [style]="{ width: '50vw' }"
    (onHide)="resetItem()">
    <div class="row g-3">
        <div class="col-12">
            <h5>Realm : {{realmViewItems?.RealmName}}</h5>
        </div>
        <div class="col-12">
            <p>OTP Client Id</p>
            <input type="text" class="form-control" [(ngModel)]="otpClient">
        </div>
        <div class="col-12">
            <p>OTP Client Secret</p>
            <input type="text" class="form-control" [(ngModel)]="otpClientSecret">
        </div>
        <div class="col-12">
            <button class="btn btn-cancel" (click)="resetItem()">Cancel</button>
            <button class="btn btn-primary ms-3" (click)="saveOtpKey()">Save OTP Key</button>
        </div>
    </div>
</p-dialog>


<p-dialog header="Add Realm" [(visible)]="visible" [breakpoints]="{ '960px': '90vw' }" [style]="{ width: '50vw' }"
    (onHide)="resetItem()">
    <div class="row g-3">
        <div class="col-12">
            <p>Realm Name</p>
            <input type="text" class="form-control" [(ngModel)]="RealmName">
        </div>
        <div class="col-12">
            <button class="btn btn-cancel" (click)="resetItem()">Cancel</button>
            <button class="btn btn-primary ms-3" (click)="addRealm()">Add Realm</button>
        </div>
    </div>
</p-dialog>